import styled from 'styled-components'

export const LiveCard = styled.div`
  --footerHeight: 55px;

  position: relative;
  background: black;

  .btn {
    border-radius: 0;
    font-weight: 800;
    letter-spacing: 1px;
  }

  &:hover .overlay {
    opacity: 1;
  }

  &:active .overlay {
    opacity: 1;
  }

  .sessionThumbnail {
    transition: 0.4s ease;
    backface-visibility: hidden;
  }

  .cardPlaceholder {
    transition: 0.4s ease;
    background: black;
    height: calc(100% - var(--footerHeight));
    min-height: 250px;
  }
  .lockOverlay {
    position: absolute;
    background: rgba(0, 0, 0, 0.4);

    transition: 0.4s ease;
    opacity: 1;
    top: 0;
    left: 0;
    right: 0;
    bottom: var(--footerHeight);
    text-align: center;
    font-size: 0.7em;
    font-weight: 700;
    /* color: var(--bs-danger); */
    color: white;

    .lock {
      position: absolute;
      top: 10px;
      right: 10px;
      svg {
        height: 30px;
      }
    }

    .ended {
      position: absolute;
      top: 0;
      left: 0;
      padding: .4em 1em;
      background: var(--bs-danger);
    }
  }

  .overlay {
    position: absolute;
    background: rgba(0, 0, 0, 0.85);
    z-index: 2;

    transition: 0.4s ease;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: var(--footerHeight);
    text-align: center;

    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1em;
    padding-top: 45px;
    padding-left: 16px;
    padding-right: 16px;
    @media (max-width: 768px) {
      position: relative;
      opacity: 1;
      padding: 0 1em 1em 1em;
      a, button {
        font-size: 0.8em;
      }
    }
  }

  .cardFooter {
    font-size: 0.85em;
    font-weight: 900;
    padding: 4px 8px;
    min-height: var(--footerHeight);
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    @media (max-width: 768px) {
      text-align: center;
      flex-direction: column;
      padding: 1em;
    }

    .addToCalBtn {
      font-weight: 600;
      font-size: 12px;
      background: transparent;
      color: white;
      border: none;

      svg {
        height: 16px;
        margin-bottom: 1px;
      }

      &:active,
      &:focus {
        outline: none;
        border: none;
        box-shadow: none;
      }

      &:hover {
        color: var(--bs-danger);
        svg {
          stroke: var(--bs-danger);
        }
      }
    }
  }
`
